import { getQueryVariable } from 'util/query'

const REDIRECT_QUERY_KEY = 'redirect'
const DEFAULT_REDIRECT_PATH = '/home'

export const getOrgSwitcherRedirect = () => {
  return getQueryVariable(REDIRECT_QUERY_KEY) || DEFAULT_REDIRECT_PATH
}

export const convertRedirectToOrgSwitcher = ({ redirect, orgId }: { redirect: string; orgId: number }) => {
  return `/org_correction/${orgId}?${REDIRECT_QUERY_KEY}=${encodeURIComponent(redirect)}`
}
